import { RefObject, useCallback, useState } from "react";

export interface UseTouchedFieldsArgs {
  validateFieldRef: RefObject<(args: { fieldId: string }) => Promise<string | null>>;
}

export const useTouchedFields = ({ validateFieldRef }: UseTouchedFieldsArgs) => {
  const [touchedFields, setTouchedFields] = useState<Set<string>>(new Set());
  const [repeatInputs, setRepeatInputs] = useState<Record<string, string>>({});
  const [repeatTouchedFields, setRepeatTouchedFields] = useState<Set<string>>(new Set());

  const setRepeatValue = useCallback((fieldId: string, value: string) => {
    setRepeatInputs((prev) => ({ ...prev, [fieldId]: value }));
  }, []);

  const handleFieldBlur = useCallback(
    (fieldId: string) => {
      setTouchedFields((prev) => new Set([...prev, fieldId]));
      validateFieldRef.current?.({ fieldId });
    },
    [validateFieldRef]
  );

  const handleRepeatBlur = useCallback(
    (fieldId: string) => {
      setRepeatTouchedFields((prev) => {
        if (prev.has(fieldId)) return prev;
        const next = new Set(prev);
        next.add(fieldId);
        return next;
      });
      setTouchedFields((prev) => (prev.has(fieldId) ? prev : new Set([...prev, fieldId])));
      validateFieldRef.current?.({ fieldId });
    },
    [validateFieldRef]
  );

  return {
    touchedFields,
    setTouchedFields,
    repeatInputs,
    setRepeatValue,
    repeatTouchedFields,
    handleFieldBlur,
    handleRepeatBlur,
  };
};
